import React from "react";
import routes from "../consts/routes.json";
import "../styles/views/login.css";
import EAButton from "../components/EAButton";
import {logout} from "../services/JwtService";
import {useHistory} from "react-router-dom";

function LoggedInEmbedded() {
    const history = useHistory();

    function launchApplication() {
        window.open(routes.EABWASSER, "_blank");
    }

    function logoutFromApplication() {
        logout();
        history.push(routes.LOGIN_EMBEDDED);
    }

    return (
        <div className={"white_background"}>
            <div id="loginLayout" className="viewContent gridl">
                <h1>Sie sind bereits angemeldet.</h1>
                <EAButton
                    type="submit"
                    onClick={launchApplication}
                    form="loginForm"
                    id="loginButton"
                    label="Anwendung starten"
                    color="primary"
                />
                <EAButton
                    type="submit"
                    onClick={logoutFromApplication}
                    form="loginForm"
                    id="loginButton"
                    label="Abmelden"
                />
            </div>
        </div>
    );
}

export default LoggedInEmbedded;
